export var LogzioCacheKeys;
(function (LogzioCacheKeys) {
    LogzioCacheKeys["HEROKU"] = "_heroku_";
    LogzioCacheKeys["SHARED_TOKENS"] = "shared-tokens";
    LogzioCacheKeys["SHARED_TOKENS_FILTERS"] = "shared-tokens-filters";
    LogzioCacheKeys["SHARE_MODE_FEATURES_ENABLED"] = "share-mode-feature-flags";
    LogzioCacheKeys["PLAN_PRICES"] = "planPrices";
    LogzioCacheKeys["SESSION_CONTEXT"] = "session-context";
    LogzioCacheKeys["KIBANA_MULTI_INDEX"] = "kibana-multi-index";
    LogzioCacheKeys["KIBANA_SEARCHED_ACCOUNTS_STATE"] = "kibana-searched-accounts-state";
    LogzioCacheKeys["SEARCHABLE_ACCOUNTS"] = "searchable-accounts";
    LogzioCacheKeys["SUB_ACCOUNTS"] = "sub-accounts";
    LogzioCacheKeys["ACCOUNTS_INDEX_MAP"] = "accounts-index-map";
    LogzioCacheKeys["KIBANA_CONFIG"] = "api/kibana/settings";
    LogzioCacheKeys["OSD_CONFIG"] = "api/opensearch-dashboards/settings";
    LogzioCacheKeys["ACCOUNTS_LIST"] = "accounts-list";
    LogzioCacheKeys["WHATS_NEW_ANNOUNCEMENTS"] = "whats-new-announcements";
    LogzioCacheKeys["HTTP_RESPONSE"] = "http_response";
    LogzioCacheKeys["LOGZIO_REGIONS"] = "logzio-regions";
    LogzioCacheKeys["SYSTEM_REGIONS"] = "system-regions";
    LogzioCacheKeys["CURRENT_ACCOUNT_ID"] = "current-account-id";
    LogzioCacheKeys["ADMIN_ACCOUNT_ID"] = "admin-account-id";
    LogzioCacheKeys["NEW_APP_TEMPORARY_INTENDED"] = "new-app-temporary-intended";
    LogzioCacheKeys["EXPANDED_INTEGRATIONS_DASHBOARDS_FOLDER"] = "expanded-integrations-dashboards-folder";
})(LogzioCacheKeys || (LogzioCacheKeys = {}));
//# sourceMappingURL=cache.enum.js.map